import { SysAdminOrgActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getOrganisationsStart = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATIONS_START, payload);
export const getOrganisationsSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATIONS_SUCCESS, payload);
export const getOrganisationsFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATIONS_FAILURE, payload);
export const getOrganisationsReset = () =>
  action(SysAdminOrgActionTypes.GET_ORGANISATIONS_RESET);

export const updateMultiOrganisationsStart = (payload: any) =>
  action(SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_START, payload);
export const updateMultiOrganisationsSuccess = () =>
  action(SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_SUCCESS);
export const updateMultiOrganisationsFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_FAILURE, payload);
export const updateMultiOrganisationsReset = () =>
  action(SysAdminOrgActionTypes.UPDATE_MULTI_ORGANISATIONS_RESET);

export const getOrganisationDetailStart = (orgId: number) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_START, orgId);
export const getOrganisationDetailSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_SUCCESS, payload);
export const getOrganisationDetailFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_FAILURE, payload);
export const getOrganisationDetailReset = () =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_DETAIL_RESET);

export const getOrganisationGroupsStart = () =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_START);
export const getOrganisationGroupsSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_SUCCESS, payload);
export const getOrganisationGroupsFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_FAILURE, payload);

export const createOrganisationStart = (payload: any) =>
  action(SysAdminOrgActionTypes.CREATE_ORGANISATION_START, payload);
export const createOrganisationSuccess = () =>
  action(SysAdminOrgActionTypes.CREATE_ORGANISATION_SUCCESS);
export const createOrganisationFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.CREATE_ORGANISATION_FAILURE, payload);
export const createOrganisationReset = () =>
  action(SysAdminOrgActionTypes.CREATE_ORGANISATION_RESET);

export const updateOrganisationStart = (payload: any) =>
  action(SysAdminOrgActionTypes.UPDATE_ORGANISATION_START, payload);
export const updateOrganisationSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.UPDATE_ORGANISATION_SUCCESS, payload);
export const updateOrganisationFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.UPDATE_ORGANISATION_FAILURE, payload);
export const updateOrganisationReset = () =>
  action(SysAdminOrgActionTypes.UPDATE_ORGANISATION_RESET);

export const getOrganisationUpdateLogsStart = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_START, payload);
export const getOrganisationUpdateLogsSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_SUCCESS, payload);
export const getOrganisationUpdateLogsFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_FAILURE, payload);
export const getOrganisationUpdateLogsReset = () =>
  action(SysAdminOrgActionTypes.GET_ORGANISATION_UPDATE_LOGS_RESET);

export const getOrganisationTransactionLimitsStart = (payload: any) =>
  action(
    SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_START,
    payload
  );
export const getOrganisationTransactionLimitsSuccess = (payload: any) =>
  action(
    SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_SUCCESS,
    payload
  );
export const getOrganisationTransactionLimitsFailure = (payload: any) =>
  action(
    SysAdminOrgActionTypes.GET_ORGANISATION_TRANSACTION_LIMITS_FAILURE,
    payload
  );

export const addOrganisationTransactionLimitsStart = (payload: any) =>
  action(
    SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_START,
    payload
  );
export const addOrganisationTransactionLimitsSuccess = () =>
  action(SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_SUCCESS);
export const addOrganisationTransactionLimitsFailure = (payload: any) =>
  action(
    SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_FAILURE,
    payload
  );
export const addOrganisationTransactionLimitsReset = () =>
  action(SysAdminOrgActionTypes.ADD_ORGANISATION_TRANSACTION_LIMITS_RESET);

export const removeOrganisationTransactionLimitsStart = (payload: any) =>
  action(
    SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_START,
    payload
  );
export const removeOrganisationTransactionLimitsSuccess = () =>
  action(SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_SUCCESS);
export const removeOrganisationTransactionLimitsFailure = (payload: any) =>
  action(
    SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_FAILURE,
    payload
  );
export const removeOrganisationTransactionLimitsReset = () =>
  action(SysAdminOrgActionTypes.REMOVE_ORGANISATION_TRANSACTION_LIMITS_RESET);

export const suspendOrganisationStart = (payload: any) =>
  action(SysAdminOrgActionTypes.SUSPEND_ORGANISATION_START, payload);
export const suspendOrganisationSuccess = (payload: any) =>
  action(SysAdminOrgActionTypes.SUSPEND_ORGANISATION_SUCCESS, payload);
export const suspendOrganisationFailure = (payload: any) =>
  action(SysAdminOrgActionTypes.SUSPEND_ORGANISATION_FAILURE, payload);
